import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=56ebd2e5&scoped=true&"
import script from "./Docs.vue?vue&type=script&lang=js&"
export * from "./Docs.vue?vue&type=script&lang=js&"
import style0 from "./Docs.vue?vue&type=style&index=0&id=56ebd2e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ebd2e5",
  null
  
)

export default component.exports